import PropTypes__default, { func, string, oneOfType, arrayOf, bool, number, oneOf, object, objectOf, node } from 'prop-types';
import { ifProp, theme } from 'styled-tools';
import styled, { css } from './styled.js';
import as from './as.js';
import Box from './Box.js';
import 'styled-components';
import './chunk-fb907809.js';
import '@emotion/is-prop-valid';
import 'react';
import 'hoist-non-react-statics';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';

var Divider = styled(Box).withConfig({
  displayName: "Divider",
  componentId: "f1uok4-0"
})(["border-color:currentColor;border-style:solid;opacity:0.2;", ";", ";"], ifProp("vertical", css(["margin:0 1em;min-height:100%;width:0;border-width:0 0 0 1px;"]), css(["margin:1em 0;height:0;border-width:1px 0 0 0;"])), theme("Divider")); // @ts-ignore

Divider.propTypes = {
  vertical: bool
};
var Divider$1 = as("hr")(Divider);

export default Divider$1;
